export default "__VITE_ASSET__CQRtB5VH__"